import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMetricsClarity = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", { d: "M45 24 38.85 9.151 24 3 9.151 9.151 3 24l6.15 14.849L24 45l11.85-4.908 3.763 3.763 4.242-4.242-3.763-3.763zM24 41.753l-12.553-5.199L6.247 24l5.199-12.553L24 6.247l12.553 5.2L41.753 24l-3.957 9.553-2.998-2.998A12.55 12.55 0 0 0 36.65 24c0-6.975-5.674-12.649-12.649-12.649S11.352 17.026 11.352 24 17.025 36.649 24 36.649c2.402 0 4.641-.685 6.555-1.852l2.998 2.998zm0-8.104c-5.32 0-9.649-4.329-9.649-9.649s4.328-9.65 9.649-9.65 9.649 4.329 9.649 9.649-4.328 9.65-9.649 9.65" }), /* @__PURE__ */ _jsx("circle", {
		cx: 24,
		cy: 24,
		r: 3.908
	})] }) })
});
export default SvgMetricsClarity;
